import { Card } from "@/paths/games/gameboardTypes";
import { Effect, EffectType, Value } from "./effectTypes";


export function isEffectType(effectType: EffectType, effect?: Effect | null): boolean {

    if (!effect)
        return false;

    if (effect.type === "multiple") {
        for (let e of effect.set) {
            if (isEffectType(effectType, e))
                return true;
        }
        return false;
    }

    if (effect.type === "iterated") {
        return isEffectType(effectType, effect.effect) || (effectType === "ritual" && isRitualAmount(effect.count));
    }

    if (effect.type === "trigger") {
        return (effectType === "ritual" && isRitualAmount(effect.then?.effect)) || isEffectType(effectType, effect.and) || effect.condition === effectType;
    }

    return effect.type === effectType || (effectType === "ritual" && isRitualAmount(effect.amount));

}

export function isRitualAmount(amount?: Value): boolean {
    if (!amount)
        return false;

    if (typeof amount === "number")
        return false;

    switch (amount.type) {
        case "ritual-value":
            return true;
        case "target-count":
            return false;
        case "property":
            return false;
        case "user":
            return false;
        case "math":
            return isRitualAmount(amount.left) || isRitualAmount(amount.right);
        case "stored-value":
            return false;
        case "modifier-value":
            return false;
    }
}

export function cardHasEffectType(effectType: EffectType, card: Card): boolean {
    const ret = (card.playAbility && isEffectType(effectType, card.playAbility))
        || (card.castAbility && isEffectType(effectType, card.castAbility))
        || (card.sustainAbility && isEffectType(effectType, card.sustainAbility))
        || (card.passiveAbility && isEffectType(effectType, card.passiveAbility));
    return ret ? ret : false;
}